exports.responseHandler = async (input, callback) => {

    const tipo = input.metadata.KM_CHAT_CONTEXT.tipo;

    const tipos = {
        "pirata": "Pirataria é Crime. Para a sua segurança e de todos os envolvidos, não instalamos softwares que não sejam free ou licenciados.",
        "pecas": "Não vendemos peças ou equipamentos. Mas podemos te auxiliar a escolher o que mais se adequa a sua necessidade, se for necessário.",
        "cabeamento": "Manutenção e instalação de cabeamentos não são considerados serviços de TI. Ainda não fazemos esse tipo de serviço, mas teremos novidades em breve.",
        "servidores": "Suporte ou administração de servidores, banco de dados e equipamentos de rede ou segurança são serviços que exigem um nível de especialidade específica. Ainda não atendemos a esse tipo de demanda, mas teremos novidades em breve.",
        "eletrica": "Manutenções, instalações elétricas e civis não são serviços de TI, por isso não atendemos a esse tipo de demanda",
        "cameras": "Implantação, suporte ou administração de câmeras de segurança não são considerados serviços de TI. Ainda não fazemos esse tipo de serviço, mas teremos novidades em breve."      
    }

    callback([{
        "message": tipos[tipo]
    }, {
        "platform": "kommunicate",
        "metadata": {
            "contentType": "300",
            "templateId": "6",
            "payload": [{
                "title": "Tenho mais dúvidas",
                "message": "Tenho mais dúvidas",
                "replyMetadata": {
                    "KM_TRIGGER_EVENT": "Dúvidas"
                }
            },{
                "title": "Agendar atendimento",
                "message": "Agendar atendimento",
                "replyMetadata": {
                    "KM_TRIGGER_EVENT": "Agendar atendimento"
                }
            }]
        }
    }])

}